export const createEmptyBinding = () => ({
  linked: false,
  sessionType: '',
  sessionId: '',
  linkType: '',
  bindTime: '',
  target: null
})

export const getCurrentDateArray = () => {
  const date = new Date()
  const year = String(date.getFullYear())
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return [year, month, day]
}

export const getInitialConsultationForm = () => ({
  contactName: '',
  phone: '',
  otherContact: '',
  source: '',
  sourceText: '',
  nearbySchoolId: '',
  nearbySchoolText: '',
  area: '',
  areaText: '',
  grade: '',
  gradeText: '',
  followUserId: '',
  followerText: '',
  studentType: '',
  studentTypeText: '',
  quality: '',
  qualityText: '',
  type: '',
  typeText: '',
  subjects: [],
  remark: ''
})

export const getInitialStudentForm = () => ({
  studentName: '',
  sex: '',
  sexText: '',
  status: 1,
  statusText: '',
  grade: '',
  gradeText: '',
  schoolId: '',
  schoolText: '',
  plannerId: '',
  plannerText: '',
  phone: '',
  birthday: '',
  source: '',
  sourceText: ''
})
